[
  {
    "name": "InvalidHexCharacter",
    "signature": "InvalidHexCharacter(bytes1)",
    "inputs": [
      "char"
    ],
    "inputTypes": [
      "bytes1"
    ],
    "source": "Common",
    "selector": "0x01d4fab6"
  },
  {
    "name": "OwnableUnauthorizedAccount",
    "signature": "OwnableUnauthorizedAccount(address)",
    "inputs": [
      "account"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "Ownable2StepUpgradeable",
    "selector": "0x118cdaa7"
  },
  {
    "name": "StringsInvalidAddressFormat",
    "signature": "StringsInvalidAddressFormat()",
    "inputs": [],
    "inputTypes": [],
    "source": "Strings",
    "selector": "0x1d15ae44"
  },
  {
    "name": "OwnableInvalidOwner",
    "signature": "OwnableInvalidOwner(address)",
    "inputs": [
      "owner"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "Ownable2StepUpgradeable",
    "selector": "0x1e4fbdf7"
  },
  {
    "name": "SafeCastOverflowedUintToInt",
    "signature": "SafeCastOverflowedUintToInt(uint256)",
    "inputs": [
      "value"
    ],
    "inputTypes": [
      "uint256"
    ],
    "source": "SafeCast",
    "selector": "0x24775e06"
  },
  {
    "name": "InvalidSecurityZone",
    "signature": "InvalidSecurityZone(int32,int32,int32)",
    "inputs": [
      "zone",
      "min",
      "max"
    ],
    "inputTypes": [
      "int32",
      "int32",
      "int32"
    ],
    "source": "TaskManager",
    "selector": "0x24cbcf36"
  },
  {
    "name": "TooManyInputs",
    "signature": "TooManyInputs(string,uint256,uint256)",
    "inputs": [
      "operation",
      "got",
      "maxAllowed"
    ],
    "inputTypes": [
      "string",
      "uint256",
      "uint256"
    ],
    "source": "TaskManager",
    "selector": "0x2b0399d5"
  },
  {
    "name": "SenderCannotBeDelegateeAddress",
    "signature": "SenderCannotBeDelegateeAddress()",
    "inputs": [],
    "inputTypes": [],
    "source": "ACL",
    "selector": "0x30dc9203"
  },
  {
    "name": "SafeCastOverflowedIntDowncast",
    "signature": "SafeCastOverflowedIntDowncast(uint8,int256)",
    "inputs": [
      "bits",
      "value"
    ],
    "inputTypes": [
      "uint8",
      "int256"
    ],
    "source": "SafeCast",
    "selector": "0x327269a7"
  },
  {
    "name": "DirectAllowForbidden",
    "signature": "DirectAllowForbidden(address)",
    "inputs": [
      "sender"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "ACL",
    "selector": "0x3809a243"
  },
  {
    "name": "MissingPrecompile",
    "signature": "MissingPrecompile(address)",
    "inputs": [
      ""
    ],
    "inputTypes": [
      "address"
    ],
    "source": "Errors",
    "selector": "0x42b01bce"
  },
  {
    "name": "PermissionInvalid_IssuerSignature",
    "signature": "PermissionInvalid_IssuerSignature()",
    "inputs": [],
    "inputTypes": [],
    "source": "ACL",
    "selector": "0x4c40eccb"
  },
  {
    "name": "ERC1967InvalidImplementation",
    "signature": "ERC1967InvalidImplementation(address)",
    "inputs": [
      "implementation"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "ERC1967Utils",
    "selector": "0x4c9c8ce3"
  },
  {
    "name": "ACLNotAllowed",
    "signature": "ACLNotAllowed(uint256,address)",
    "inputs": [
      "handle",
      "account"
    ],
    "inputTypes": [
      "uint256",
      "address"
    ],
    "source": "TaskManager",
    "selector": "0x4d13139e"
  },
  {
    "name": "InvalidTypeOrSecurityZone",
    "signature": "InvalidTypeOrSecurityZone(string)",
    "inputs": [
      "operation"
    ],
    "inputTypes": [
      "string"
    ],
    "source": "TaskManager",
    "selector": "0x52b50ae1"
  },
  {
    "name": "ERC1967InvalidAdmin",
    "signature": "ERC1967InvalidAdmin(address)",
    "inputs": [
      "admin"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "ERC1967Utils",
    "selector": "0x62e77ba2"
  },
  {
    "name": "ERC1967InvalidBeacon",
    "signature": "ERC1967InvalidBeacon(address)",
    "inputs": [
      "beacon"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "ERC1967Utils",
    "selector": "0x64ced0ec"
  },
  {
    "name": "InvalidEncryptedInput",
    "signature": "InvalidEncryptedInput(uint8,uint8)",
    "inputs": [
      "got",
      "expected"
    ],
    "inputTypes": [
      "uint8",
      "uint8"
    ],
    "source": "FHE",
    "selector": "0x67cf3071"
  },
  {
    "name": "SafeCastOverflowedUintDowncast",
    "signature": "SafeCastOverflowedUintDowncast(uint8,uint256)",
    "inputs": [
      "bits",
      "value"
    ],
    "inputTypes": [
      "uint8",
      "uint256"
    ],
    "source": "SafeCast",
    "selector": "0x6dfcc650"
  },
  {
    "name": "DecryptionResultNotReady",
    "signature": "DecryptionResultNotReady(uint256)",
    "inputs": [
      "ctHash"
    ],
    "inputTypes": [
      "uint256"
    ],
    "source": "TaskManager",
    "selector": "0x70cf6554"
  },
  {
    "name": "InvalidSigner",
    "signature": "InvalidSigner(address,address)",
    "inputs": [
      "signer",
      "expectedSigner"
    ],
    "inputTypes": [
      "address",
      "address"
    ],
    "source": "TaskManager",
    "selector": "0x7ba5ffb5"
  },
  {
    "name": "InvalidInputType",
    "signature": "InvalidInputType(uint8,uint8)",
    "inputs": [
      "actual",
      "expected"
    ],
    "inputTypes": [
      "uint8",
      "uint8"
    ],
    "source": "TaskManager",
    "selector": "0x884a0e9d"
  },
  {
    "name": "InvalidSignature",
    "signature": "InvalidSignature()",
    "inputs": [],
    "inputTypes": [],
    "source": "TaskManager",
    "selector": "0x8baa579f"
  },
  {
    "name": "PermissionInvalid_RecipientSignature",
    "signature": "PermissionInvalid_RecipientSignature()",
    "inputs": [],
    "inputTypes": [],
    "source": "ACL",
    "selector": "0x8e143bf7"
  },
  {
    "name": "SecurityZoneOutOfBounds",
    "signature": "SecurityZoneOutOfBounds(int32)",
    "inputs": [
      "value"
    ],
    "inputTypes": [
      "int32"
    ],
    "source": "Common",
    "selector": "0x8f568bf8"
  },
  {
    "name": "InvalidInputForFunction",
    "signature": "InvalidInputForFunction(string,uint8)",
    "inputs": [
      "functionName",
      "inputType"
    ],
    "inputTypes": [
      "string",
      "uint8"
    ],
    "source": "TaskManager",
    "selector": "0x91b4b378"
  },
  {
    "name": "StringsInvalidChar",
    "signature": "StringsInvalidChar()",
    "inputs": [],
    "inputTypes": [],
    "source": "Strings",
    "selector": "0x94e2737e"
  },
  {
    "name": "RandomFunctionNotSupported",
    "signature": "RandomFunctionNotSupported()",
    "inputs": [],
    "inputTypes": [],
    "source": "TaskManager",
    "selector": "0x98e08ab0"
  },
  {
    "name": "AddressEmptyCode",
    "signature": "AddressEmptyCode(address)",
    "inputs": [
      "target"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "Address",
    "selector": "0x9996b315"
  },
  {
    "name": "InvalidInputsAmount",
    "signature": "InvalidInputsAmount(string,uint256,uint256)",
    "inputs": [
      "operation",
      "got",
      "expected"
    ],
    "inputTypes": [
      "string",
      "uint256",
      "uint256"
    ],
    "source": "TaskManager",
    "selector": "0x9a84351c"
  },
  {
    "name": "SafeCastOverflowedIntToUint",
    "signature": "SafeCastOverflowedIntToUint(int256)",
    "inputs": [
      "value"
    ],
    "inputTypes": [
      "int256"
    ],
    "source": "SafeCast",
    "selector": "0xa8ce4432"
  },
  {
    "name": "OnlyAggregatorAllowed",
    "signature": "OnlyAggregatorAllowed(address)",
    "inputs": [
      "caller"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "TaskManager",
    "selector": "0xa974a0fe"
  },
  {
    "name": "UUPSUnsupportedProxiableUUID",
    "signature": "UUPSUnsupportedProxiableUUID(bytes32)",
    "inputs": [
      "slot"
    ],
    "inputTypes": [
      "bytes32"
    ],
    "source": "UUPSUpgradeable",
    "selector": "0xaa1d49a4"
  },
  {
    "name": "FailedDeployment",
    "signature": "FailedDeployment()",
    "inputs": [],
    "inputTypes": [],
    "source": "Errors",
    "selector": "0xb06ebf3d"
  },
  {
    "name": "InvalidOperationInputs",
    "signature": "InvalidOperationInputs(string)",
    "inputs": [
      "operation"
    ],
    "inputTypes": [
      "string"
    ],
    "source": "TaskManager",
    "selector": "0xb31612aa"
  },
  {
    "name": "ERC1967NonPayable",
    "signature": "ERC1967NonPayable()",
    "inputs": [],
    "inputTypes": [],
    "source": "ERC1967Utils",
    "selector": "0xb398979f"
  },
  {
    "name": "UnsupportedType",
    "signature": "UnsupportedType(uint256)",
    "inputs": [
      "t"
    ],
    "inputTypes": [
      "uint256"
    ],
    "source": "TaskManager",
    "selector": "0xcabe5ce4"
  },
  {
    "name": "PermissionInvalid_Disabled",
    "signature": "PermissionInvalid_Disabled()",
    "inputs": [],
    "inputTypes": [],
    "source": "ACL",
    "selector": "0xcbd3a966"
  },
  {
    "name": "InsufficientBalance",
    "signature": "InsufficientBalance(uint256,uint256)",
    "inputs": [
      "balance",
      "needed"
    ],
    "inputTypes": [
      "uint256",
      "uint256"
    ],
    "source": "Errors",
    "selector": "0xcf479181"
  },
  {
    "name": "SenderNotAllowed",
    "signature": "SenderNotAllowed(address)",
    "inputs": [
      "sender"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "ACL",
    "selector": "0xd0d25976"
  },
  {
    "name": "AlreadyDelegated",
    "signature": "AlreadyDelegated()",
    "inputs": [],
    "inputTypes": [],
    "source": "ACL",
    "selector": "0xd1860468"
  },
  {
    "name": "FailedCall",
    "signature": "FailedCall()",
    "inputs": [],
    "inputTypes": [],
    "source": "Errors",
    "selector": "0xd6bda275"
  },
  {
    "name": "ECDSAInvalidSignatureS",
    "signature": "ECDSAInvalidSignatureS(bytes32)",
    "inputs": [
      "s"
    ],
    "inputTypes": [
      "bytes32"
    ],
    "source": "ECDSA",
    "selector": "0xd78bce0c"
  },
  {
    "name": "NotInitializing",
    "signature": "NotInitializing()",
    "inputs": [],
    "inputTypes": [],
    "source": "Ownable2StepUpgradeable",
    "selector": "0xd7e6bcf8"
  },
  {
    "name": "CofheIsUnavailable",
    "signature": "CofheIsUnavailable()",
    "inputs": [],
    "inputTypes": [],
    "source": "TaskManager",
    "selector": "0xd8aba367"
  },
  {
    "name": "OnlyTaskManagerAllowed",
    "signature": "OnlyTaskManagerAllowed(address)",
    "inputs": [
      "caller"
    ],
    "inputTypes": [
      "address"
    ],
    "source": "PlaintextsStorage",
    "selector": "0xdce3ec0a"
  },
  {
    "name": "UUPSUnauthorizedCallContext",
    "signature": "UUPSUnauthorizedCallContext()",
    "inputs": [],
    "inputTypes": [],
    "source": "UUPSUpgradeable",
    "selector": "0xe07c8dba"
  },
  {
    "name": "StringsInsufficientHexLength",
    "signature": "StringsInsufficientHexLength(uint256,uint256)",
    "inputs": [
      "value",
      "length"
    ],
    "inputTypes": [
      "uint256",
      "uint256"
    ],
    "source": "Strings",
    "selector": "0xe22e27eb"
  },
  {
    "name": "InvalidAddress",
    "signature": "InvalidAddress()",
    "inputs": [],
    "inputTypes": [],
    "source": "TaskManager",
    "selector": "0xe6c4247b"
  },
  {
    "name": "PermissionInvalid_Expired",
    "signature": "PermissionInvalid_Expired()",
    "inputs": [],
    "inputTypes": [],
    "source": "ACL",
    "selector": "0xed0764a1"
  },
  {
    "name": "ECDSAInvalidSignature",
    "signature": "ECDSAInvalidSignature()",
    "inputs": [],
    "inputTypes": [],
    "source": "ECDSA",
    "selector": "0xf645eedf"
  },
  {
    "name": "InvalidInitialization",
    "signature": "InvalidInitialization()",
    "inputs": [],
    "inputTypes": [],
    "source": "Ownable2StepUpgradeable",
    "selector": "0xf92ee8a9"
  },
  {
    "name": "ECDSAInvalidSignatureLength",
    "signature": "ECDSAInvalidSignatureLength(uint256)",
    "inputs": [
      "length"
    ],
    "inputTypes": [
      "uint256"
    ],
    "source": "ECDSA",
    "selector": "0xfce698f7"
  }
]